export const userRoutes = {
	userIndex: '/users',
	userAdd: '/users/add',
	userEdit: (id?: string) => `/users/${id ?? ':id'}`,
	userChangePassword: (id?: string) => `/users/${id ?? ':id'}/password-change`,
	userHistory: (id?: string) => `/users/${id ?? ':id'}/history`
} as const
